import "./track-event-selector.css";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { FaTimes } from "react-icons/fa";
import msiLogo from "./assets/Micro Strategies Logo 2025_RBG_Primary Horizontal_White_1200 px.png";
import dragInsightsLogo from "./assets/drag-insights-logos-lights-white.png";
import { TRACK_LIST_API, LATEST_TRACK_API } from "./utils/apiUrlList";
import { api } from "./utils/apiClientWithCsrf";
import { urlBasedTrackListFilter , useDomainConfig} from "./utils/trackListFilter";

export const TRACK_EVENT_SELECTION_KEY = "trackEventSelection";

export const TRACK_SEARCH_CRITERIA_KEY = "searchCriteria"

const TrackEventSelector = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.from || "/timeslip";

  const [trackList, setTrackList] = useState([]);
  const [loadingTracks, setLoadingTracks] = useState(true);
  const [trackError, setTrackError] = useState(false);

  const [selectedTrackValue, setSelectedTrackValue] = useState("");
  const [selectedEventValue, setSelectedEventValue] = useState("");
  const [selectedEventName, setSelectedEventName] = useState("");
  const [selectedTrackId, setSelectedTrackId] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");

  const [autoFillLatestEventFlag, setAutoFillLatestEventFlag] = useState(false);

  const [allowEditSelection, setAllowEditSelection] = useState(
    () => JSON.parse(localStorage.getItem("allowEditSelection") ?? "false")
  );

  const [trackNameDisabled, setTrackNameDisabled] = useState(false);
  
  const domainConfig = useDomainConfig();

 const { filteredTrackList , shouldEnableTrackNameDropdown } = urlBasedTrackListFilter(TRACK_EVENT_SELECTION_KEY, trackList);

useEffect(() => {
 
  setTrackNameDisabled(!shouldEnableTrackNameDropdown);
  if(shouldEnableTrackNameDropdown === false ){
  // setTrackList(filteredTrackList);
  setSelectedTrackId(filteredTrackList[0]?.trackId || "");
  setSelectedTrackValue(filteredTrackList[0]?.trackName || "");
}
}, [trackList, filteredTrackList, shouldEnableTrackNameDropdown]);




  //This is because the trackId is needed to filter the event list based on the selected track. 
  // The filteredTrackList is used to get the trackId of the first item in the list, 
  // which is then used to filter the eventOptions.
  //TrackId remains the same for all events of a track, so we can use the first item to get the trackId.

  // const filteredTrackListTrackId = filteredTrackList[0]?.trackId;
  // const filteredTrackListTrackName = filteredTrackList[0]?.trackName;

  const trackOptions = Object.values(
  filteredTrackList.reduce((acc, item) => {
    if (!acc[item.trackId]) {
      acc[item.trackId] = {
        trackId: item.trackId,
        trackName: item.trackName,
      };
    }
    return acc;
  }, {})
);

  const eventOptions = trackList
  .filter((item) => String(item.trackId) === String(selectedTrackId))
  .map((item) => ({
    eventName: item.eventName,
    eventId: item.eventId,
    startDate: item.startDate,
    endDate: item.endDate,
  }));

  // On mount: fetch track list and restore any saved selection
  useEffect(() => {
    const fetchTracks = async () => {
      setLoadingTracks(true);
      setTrackError(false);
      try {
        const response = await api.get(TRACK_LIST_API, {
          withCredentials: true,
        });
        const data = response.data;
        setTrackList(data);

        // Restore saved selection after track list is loaded
        const saved = localStorage.getItem(TRACK_EVENT_SELECTION_KEY);
        if (saved) {
          const { trackName, eventId, eventName, trackId ,startDate, endDate} = JSON.parse(saved);
          if (trackName) setSelectedTrackValue(trackName);
          if (eventId) setSelectedEventValue(eventId);
          if (eventName) setSelectedEventName(eventName);
          if (trackId) setSelectedTrackId(trackId);
          if (startDate) setSelectedStartDate(startDate);   
          if (endDate) setSelectedEndDate(endDate);
        }
      } catch (error) {
        console.error("Error fetching track list:", error);
        setTrackError(true);
      } finally {
        setLoadingTracks(false);
      }
    };
    fetchTracks();
  }, []);

  const handleClose = () => {
    const hasSavedSelection = !!localStorage.getItem(TRACK_EVENT_SELECTION_KEY);
    if (!hasSavedSelection) {
      setCloseWarning(true);
      setTimeout(() => setCloseWarning(false), 3000);
      return;
    }
    // setAllowEditSelection(false);
    navigate(returnTo);
  };

const handleTrackChange = (e) => {
  const selectedTrackId = e.target.value;

  // find using trackId (not trackName)
  const foundTrack = trackList.find(
    (item) => String(item.trackId) === String(selectedTrackId)
  );

  if (foundTrack) {
    setSelectedTrackId(foundTrack.trackId);      // controls dropdown
    setSelectedTrackValue(foundTrack.trackName); // store name separately
  } else {
    setSelectedTrackId("");
    setSelectedTrackValue("");
  }

  if(allowEditSelection ){
    setAutoFillLatestEventFlag((prev) => !prev);
  }

  // reset dependent fieldsac
  setSelectedEventValue("");
  setSelectedEventName("");
};

  const handleEventChange = (e) => {
    const selectedId = e.target.value;
    setSelectedEventValue(selectedId);
    const found = eventOptions.find((ev) => String(ev.eventId) === String(selectedId));
     if (found) {
    setSelectedEventName(found.eventName);
    setSelectedStartDate(found.startDate); 
    setSelectedEndDate(found.endDate);     
  }
  };

  const handleViewTimeslips = () => {
    const selection = {
      trackName: selectedTrackValue,
      eventId: selectedEventValue,
      eventName: selectedEventName,
      trackId: selectedTrackId,
      startDate: selectedStartDate,
      endDate: selectedEndDate,  
    };
    localStorage.setItem(TRACK_EVENT_SELECTION_KEY, JSON.stringify(selection));
    window.dispatchEvent(new CustomEvent("track-changed", { detail: selection }));

    const getSearchCriteria = localStorage.getItem(TRACK_SEARCH_CRITERIA_KEY);
    if(getSearchCriteria){
      localStorage.removeItem(TRACK_SEARCH_CRITERIA_KEY);
    }
     const getSearchResults = localStorage.getItem("searchResults");
    if(getSearchResults){
      localStorage.removeItem("searchResults");
    }
    const getListFlag = localStorage.getItem("listFlag")
    if(getListFlag){
      localStorage.removeItem("listFlag")
    }
    const getIncreRaceIdList = localStorage.getItem("increRaceIdList")
    if(getIncreRaceIdList){
      localStorage.removeItem("increRaceIdList")
    }
    const getSelectedCards = localStorage.getItem("selectedCards")
    if(getSelectedCards){
      localStorage.removeItem("selectedCards")
    }
    localStorage.removeItem("searchPage");
    navigate(returnTo);
  };

  const isReady = selectedTrackValue && selectedEventValue;

  const [closeWarning, setCloseWarning] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const infoRef = useRef(null);

  useEffect(() => {
    if (!infoOpen) return;
    const handleOutsideClick = (e) => {
      if (infoRef.current && !infoRef.current.contains(e.target)) {
        setInfoOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [infoOpen]);

  

  useEffect(() => {
    localStorage.setItem("allowEditSelection", JSON.stringify(allowEditSelection));
  }, [allowEditSelection]);

  useEffect(() => {
    if (!allowEditSelection || (selectedTrackId === "" || selectedTrackId === undefined || selectedTrackId === null)) return;
    const autoFillLatestTrack = async () => {
      try {
        const response = await api.get(LATEST_TRACK_API, { 
          params: { trackId: selectedTrackId },
          withCredentials: true });


        const data = response.data;

        // Find the track name from the already-loaded trackList using trackId
        const foundTrack = trackList.find(
          (item) => String(item.trackId) === String(data.trackId)
        );

        if (data.trackId)   setSelectedTrackId(String(data.trackId));
        if (foundTrack)     setSelectedTrackValue(foundTrack.trackName);
        if (data.eventId)   setSelectedEventValue(String(data.eventId));
        if (data.eventName) setSelectedEventName(data.eventName);
        if (data.startDate) setSelectedStartDate(data.startDate);
        if (data.endDate)   setSelectedEndDate(data.endDate);

      } catch (error) {
        console.error("[testAPI] error:", error);
      }
    };
    autoFillLatestTrack();
  }, [allowEditSelection , autoFillLatestEventFlag]);

  return (
    <div className="selector-container">

      <div className="selector-card">
        <button
          type="button"
          className="selector-close"
          onClick={handleClose}
          aria-label="Close"
          title="Close"
        >
          <FaTimes />
        </button>
        {closeWarning && (
          <div className="selector-close-warning">
            Please select a track &amp; event
          </div>
        )}
        <h2 className="selector-title">Select Track &amp; Event</h2>
        <p className="selector-subtitle">Select a track and event to view race results</p>

        {loadingTracks ? (
          <div className="selector-loading">
            <div className="loader"></div>
            <p>Loading tracks…</p>
          </div>
        ) : trackError ? (
          <div className="selector-error">
            <p>Unable to load tracks. Please check your connection and try again.</p>
            <button
              className="selector-btn-retry"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        ) : (
          <>
            <div className="selector-field">
              <label htmlFor="trackSelect" className="selector-label">
                Track Name
              </label>
              <select
                id="trackSelect"
                className="selector-select"
                value={selectedTrackId}
                onChange={handleTrackChange}
                disabled ={trackNameDisabled}
              >
                {trackOptions.map((track) => (
                  <option key={track.trackId} value={track.trackId}>
                    {track.trackName}
                  </option>
                ))}
              </select>
            </div>

            <div className="selector-field">
              <label htmlFor="eventSelect" className="selector-label">
                Event Name
              </label>
              <select
                id="eventSelect"
                className="selector-select"
                value={selectedEventValue}
                onChange={handleEventChange}
                disabled={!selectedTrackValue || allowEditSelection}
              >
                <option value="">-- Select an Event --</option>
                {eventOptions.map((ev) => (
                  <option key={ev.eventId} value={ev.eventId}>
                    {ev.eventName} ({ev.startDate} to {ev.endDate})
                  </option>
                ))}
              </select>
            </div>

            <div className="selector-field">
              <div className="selector-toggle" style={{ position: "relative" }} ref={infoRef}>
                <span className="selector-toggle-label">Auto-fill Latest Event</span>
                <button
                  type="button"
                  className="selector-info-btn"
                  onClick={() => setInfoOpen((o) => !o)}
                  aria-label="More info"
                >
                  &#9432;
                </button>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={allowEditSelection}
                    onChange={(e) => setAllowEditSelection(e.target.checked)}
                    disabled={!selectedTrackValue}
                  />
                  <span className="slider"></span>
                </label>
                {infoOpen && (
                  <div className="selector-info-box">
                    When enabled, the Event field is automatically set to the latest event for the selected track.
                    The Event dropdown is locked while this option is active. 
                    To select a different event, 
                    disable this option and choose an event manually.

                  </div>
                )}
              </div>
            </div>

            <button
              className="selector-btn-view"
              disabled={!isReady}
              onClick={handleViewTimeslips}
            >
              View Race Results
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TrackEventSelector;
